import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
export var EditorZoom = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._zoomLevel = 0;
    this._onDidChangeZoomLevel = new Emitter();
    this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
  }

  _createClass(_class, [{
    key: "getZoomLevel",
    value: function getZoomLevel() {
      return this._zoomLevel;
    }
  }, {
    key: "setZoomLevel",
    value: function setZoomLevel(zoomLevel) {
      zoomLevel = Math.min(Math.max(-5, zoomLevel), 20);

      if (this._zoomLevel === zoomLevel) {
        return;
      }

      this._zoomLevel = zoomLevel;

      this._onDidChangeZoomLevel.fire(this._zoomLevel);
    }
  }]);

  return _class;
}())();